import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const startSession = async (intakeData) => {
  const response = await api.post('/api/quickscore/start', intakeData);
  return response.data;
};

export const getSession = async (sessionId) => {
  const response = await api.get(`/api/quickscore/${sessionId}`);
  return response.data;
};

export const saveCategory = async (sessionId, category, data) => {
  const response = await api.patch(`/api/quickscore/${sessionId}/${category}`, data);
  return response.data;
};

export const uploadEvidence = async (sessionId, category, question, file) => {
  const formData = new FormData();
  formData.append('category', category);
  formData.append('question', question);
  formData.append('file', file);
  
  const response = await api.post(`/api/quickscore/${sessionId}/evidence`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const deleteEvidence = async (sessionId, evidenceId) => {
  const response = await api.delete(`/api/quickscore/${sessionId}/evidence/${evidenceId}`);
  return response.data;
};

export const completeSurvey = async (sessionId) => {
  const response = await api.post(`/api/quickscore/${sessionId}/complete`);
  return response.data;
};

export const updateUserInfo = async (sessionId, userData) => {
  const response = await api.patch(`/api/quickscore/${sessionId}/user-info`, userData);
  return response.data;
};

export const getResults = async (sessionId) => {
  const response = await api.get(`/api/quickscore/${sessionId}/results`);
  return response.data;
};

export const exportPDF = async (sessionId, unlocked = false) => {
  const response = await api.post(`/api/quickscore/${sessionId}/export/pdf${unlocked ? '?unlock=true' : ''}`, {}, {
    responseType: 'blob'
  });
  return response.data;
};

export const getRubricData = async () => {
  const response = await api.get('/api/rubric-data');
  return response.data;
};

export default api;
